import React, { useEffect, useRef } from 'react';
import ga from '../../utils/gaConnect';
import { useDispatch } from 'react-redux';
import {
  initPoSDK,
  initPoSDKAfteDownload,
  usePOWebofficeSDKDispatch,
  usePOWebofficeSDKState
} from '../../context/poWebOfficeSDKContext';
import {
  DIALOG_TYPE,
  DOC_FORMAT_CONFIG_VALUES,
  PO_EDIT_MODE,
  PRODUCT_TYPE
} from '../../define/global';
import { openDialog } from '../../store/modules/dialog';
import { useGenCommonConfig } from '../../utils/poSDKHelper';
import { genS3DownloadLink } from '../../utils/s3Connect';
import { setEditMode, setFileName } from '../../store/modules/docInfo';
import { PO_WEBOFFCE_SDK_FAIL } from '../../context/poWebOfficeSDKContext';
import { useAppDataSliceSelector } from '../../store/modules/appData';
import { isDevicePC, useGetHomeURLWithProductType } from '../../utils/util';
import { showAppInstall } from '../../store/modules/popup';
import styled from 'styled-components';
import {
  removeTempfiles,
  useIndexedDBDispatch,
  useIndexedDBState
} from '../../context/indexedDBContext';
import { CHANGE_FONT_TEMP_FILE_EXT } from '../../utils/FontsUtil';
import { getExtension } from '../../utils/FileControlUtil';

const WebOfficeContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;

const WEB_OFFICE_CONTAINER_ELE_ID = 'WebOfficeContaier';

function POSdk({ res, mode, shareID, su, extFontsInfo }) {
  //const initPO = useRef(false);
  //const poInstance = useRef(null);
  const poSDKContextDispatch = usePOWebofficeSDKDispatch();
  const poSDKContextState = usePOWebofficeSDKState();
  const dispatch = useDispatch();
  const appData = useAppDataSliceSelector();
  const isPCView = isDevicePC(appData.deviceType);
  const indexedDBState = useIndexedDBState();
  const indexedDBDispatch = useIndexedDBDispatch();
  const getHomeURLWithProductType = useGetHomeURLWithProductType();

  const { data, complete, error } = extFontsInfo;

  const isLoad = useRef(false);
  const config = useGenCommonConfig(mode, DOC_FORMAT_CONFIG_VALUES.sdk.documnetType, data);

  const isStartedInitialze = useRef(false);

  useEffect(() => {
    if (
      poSDKContextState.poInstance === null &&
      poSDKContextState.isInitializing === false &&
      poSDKContextState.error === null &&
      isStartedInitialze.current === false
    ) {
      if (mode === PO_EDIT_MODE.NONE) return;
      if (complete === false) return;

      isStartedInitialze.current = true;

      if (shareID !== '') {
        //ga.event({ category: 'shardID', action: shareID });
        if (su === true) {
          const url = genS3DownloadLink(shareID);
          initPoSDKAfteDownload(
            dispatch,
            poSDKContextDispatch,
            WEB_OFFICE_CONTAINER_ELE_ID,
            config,
            url,
            shareID,
            (fileName) => {
              dispatch(setFileName(fileName));
              if (!isPCView && appData.productType !== PRODUCT_TYPE.WITH_WHALE_SPACE) {
                dispatch(showAppInstall());
              }
            },
            () => {
              dispatch(openDialog({ dialogType: DIALOG_TYPE.DIALOG_INVALID_SHARE_LINK }));
            },
            (executeTime) => {
              ga.event({ category: '공유문서', action: '공유문서보기', value: executeTime });
            }
          );
        } else {
          dispatch(openDialog({ dialogType: DIALOG_TYPE.DIALOG_INVALID_SHARE_LINK }));
          poSDKContextDispatch({ type: PO_WEBOFFCE_SDK_FAIL, payload: 'sharedID invalid' });
        }
      } else {
        initPoSDK(
          poSDKContextDispatch,
          WEB_OFFICE_CONTAINER_ELE_ID,
          config,
          dispatch,
          (executeTime) => {
            ga.event({ category: '성능', action: '웹오피스로딩', value: executeTime });
          }
        );
      }
    } else if (poSDKContextState.poInstance && isLoad.current === false && res) {
      isLoad.current = true;
      const start = new Date();
      let fileName = res.name;
      const tmpExt = `${CHANGE_FONT_TEMP_FILE_EXT}`;
      if (fileName.endsWith(tmpExt)) {
        fileName = fileName.substring(0, fileName.length - tmpExt.length);
      }
      const copyed = new File([res], fileName);

      poSDKContextState.poInstance.handle
        .openDocument({ name: copyed.name, blob: copyed })
        .then(() => {
          if (appData.productType === PRODUCT_TYPE.WITH_DROPBOX) {
            ga.event({ category: '문서열기', action: '드롭박스', value: new Date() - start });
          } else if (appData.productType === PRODUCT_TYPE.WITH_GOOGLE_DRIVE) {
            ga.event({ category: '문서열기', action: '구글드라이브', value: new Date() - start });
          } else {
            ga.event({
              category: '문서열기',
              action: '기존문서',
              label: '파일탭',
              value: new Date() - start
            });
          }
          if (poSDKContextState.poInstance.handle.getViewMode() === PO_EDIT_MODE.READ) {
            //Open Read Only
            dispatch(setEditMode(PO_EDIT_MODE.READ));
          }
          ga.event({
            category: '문서열기',
            action: '문서포맷',
            label: getExtension(copyed.name).toLowerCase()
          });
        })
        .catch((err) => {
          ga.event({
            category: '예외 케이스',
            action: '열람실패_미지원',
            label: `엔진(${err.errorCode})`
          });
          err.closeDialog.then(() =>
            window.open(
              getHomeURLWithProductType(DOC_FORMAT_CONFIG_VALUES.sdk.documnetType.toUpperCase()),
              '_self',
              'noopener,noreferrer'
            )
          );
        })
        .finally(() => {
          removeTempfiles({
            state: indexedDBState,
            dispatch: indexedDBDispatch,
            files: indexedDBState.files
          });
        });
    }
  }, [poSDKContextState, mode, poSDKContextDispatch, shareID, dispatch, config, su, res, complete]);

  return (
    <>
      <WebOfficeContainer id={WEB_OFFICE_CONTAINER_ELE_ID} />
    </>
  );
}

export default React.memo(POSdk);
